@if (showHeading() && title()) {
  <h2 class="font-headline-medium" [class.ms-clear]="isNewBrand()" [class.mr-large-b]="!isNewBrand()">
    @if (showLabel()) {
      <span class="block travel-guide-label" [class.light-type]="!isNewBrand()">{{
        'travelGuide' | finLocalization
      }}</span>
    }
    <span [class.bold-type]="!isNewBrand()">{{ title() }}</span>
  </h2>
}

@if (mediaType() === 'video') {
  <fin-video [videoUrl]="videoUrl()" [videoTitle]="title()" />
}

@if (mediaType() === 'picture') {
  <div class="mr-xsmall-y">
    <fin-content-image [imageData$]="mediaPicture$" />
  </div>
}

@if (phraseGroups(); as pg) {
  @for (phraseGroup of pg; track $index) {
    <fin-travel-guide-phrases [phraseGroup]="phraseGroup" class="travel-guide-text block" />
  }
} @else {
  <span
    [innerHTML]="text() | finEmpty | finSafe: 'html'"
    class="travel-guide-text block mr-small-t"
    [class.mr-large-b]="!isNewBrand()"
    [class.mr-small-b]="isNewBrand()"
  ></span>
}
